// export const DEFAULT_DATES  = [
//     { value: "2021-01-01,2021-01-31", label: "JAN-21" },
//     { value: "2021-02-01,2021-02-28", label: "FEB-21" },
//     { value: "2021-03-01,2021-03-31", label: "MAR-21" },
//     { value: "2021-04-01,2021-04-30", label: "APR-21" },
//     { value: "2021-05-01,2021-05-31", label: "MAY-21" },
//     { value: "2021-06-01,2021-06-30", label: "JUN-21" },
//     { value: "2021-07-01,2021-07-31", label: "JUL-21" },
//     { value: "2021-08-01,2021-08-31", label: "AUG-21" },
//     { value: "2021-09-01,2021-09-30", label: "SEP-21" },
//     { value: "2021-10-01,2021-10-31", label: "OCT-21" },
//     { value: "2021-11-01,2021-11-30", label: "NOV-21" },
//     { value: "2021-12-01,2021-12-31", label: "DEC-21" },
//     { value: "2022-01-01,2022-01-31", label: "JAN-22" },
//     { value: "2022-02-01,2022-02-28", label: "FEB-22" },
//     { value: "2022-03-01,2022-03-31", label: "MAR-22" },
//     { value: "2022-04-01,2022-04-30", label: "APR-22" },
//     { value: "2022-05-01,2022-05-31", label: "MAY-22" },
//     { value: "2022-06-01,2022-06-30", label: "JUN-22" },
//     { value: "2022-07-01,2022-07-31", label: "JUL-22" },
//     { value: "2022-08-01,2022-08-31", label: "AUG-22" },
//     { value: "2022-09-01,2022-09-30", label: "SEP-22" },
//     { value: "2022-10-01,2022-10-31", label: "OCT-22" },
//     { value: "2022-11-01,2022-11-30", label: "NOV-22" },
//     { value: "2022-12-01,2022-12-31", label: "DEC-22" },
//     { value: "2023-01-01,2023-01-31", label: "JAN-23" },
//     { value: "2023-02-01,2023-02-28", label: "FEB-23" },
//     { value: "2023-03-01,2023-03-31", label: "MAR-23" },
//     { value: "2023-04-01,2023-04-30", label: "APR-23" },
//     { value: "2023-05-01,2023-05-31", label: "MAY-23" },
//     { value: "2023-06-01,2023-06-30", label: "JUN-23" },
//     { value: "2023-07-01,2023-07-31", label: "JUL-23" },
//     { value: "2023-08-01,2023-08-31", label: "AUG-23" },
//     { value: "2023-09-01,2023-09-30", label: "SEP-23" },
//     { value: "2023-10-01,2023-10-31", label: "OCT-23" },
//     { value: "2023-11-01,2023-11-30", label: "NOV-23" },
//     { value: "2023-12-01,2023-12-31", label: "DEC-23" },
//     { value: "2024-01-01,2024-01-31", label: "JAN-24" },
//     { value: "2024-02-01,2024-02-29", label: "FEB-24" }, // Leap year
//     { value: "2024-03-01,2024-03-31", label: "MAR-24" },
//     { value: "2024-04-01,2024-04-30", label: "APR-24" },
//     { value: "2024-05-01,2024-05-31", label: "MAY-24" },
//     { value: "2024-06-01,2024-06-30", label: "JUN-24" },
//     { value: "2024-07-01,2024-07-31", label: "JUL-24" },
//     { value: "2024-08-01,2024-08-31", label: "AUG-24" },
//     { value: "2024-09-01,2024-09-30", label: "SEP-24" },
//     { value: "2024-10-01,2024-10-31", label: "OCT-24" },
//     { value: "2024-11-01,2024-11-30", label: "NOV-24" }, // Partial month
//     {value: "2024-11-01,2024-11-30,Model 1", label: "NOV-24 (Forecast 1)", forecast : true, model: "Model 1"},
//     {value: "2024-11-01,2024-11-30,Model 2", label: "NOV-24 (Forecast 2)", forecast : true, model: "Model 2"},

//     { value: "2024-12-01,2024-12-31", label: "DEC-24" },
//     {value: "2024-12-01,2024-12-31,Model 1", label: "DEC-24 (Forecast 1)", forecast : true, model: "Model 1"},
//     {value: "2024-12-01,2024-12-31,Model 2", label: "DEC-24 (Forecast 2)", forecast : true, model: "Model 2"},
//     { value: "2025-01-01,2025-01-31", label: "JAN-25" },

//     {value: "2025-01-01,2025-01-31,Model 1", label: "JAN-25 (Forecast 1)", forecast : true, model: "Model 1"},
//     {value: "2025-01-01,2025-01-31,Model 2", label: "JAN-25 (Forecast 2)", forecast : true, model: "Model 2"},
//     {value: "2025-02-01,2025-02-28,Model 1", label: "FEB-25 (Forecast 1)",forecast : true, model: "Model 1"},
//     {value: "2025-02-01,2025-02-28,Model 2", label: "FEB-25 (Forecast 2)",forecast : true, model: "Model 2"},
//     {value: "2025-03-01,2025-03-31,Model 1", label: "MAR-25 (Forecast 1)",forecast : true, model: "Model 1"},
//     {value: "2025-03-01,2025-03-31,Model 2", label: "MAR-25 (Forecast 2)",forecast : true, model: "Model 2"},

//   ].reverse();

export interface DateEntry {
  value: string;
  label: string;
  forecast?: boolean;
  model?: string;
}

export interface DateEntry {
  value: string;
  label: string;
  forecast?: boolean;
  model?: string;
}

export const DEFAULT_DATES: DateEntry[] = [];

const startYear = 2019;
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
// Fix: Month is 0-indexed, December is 11 not 12
const currentMonth = 11; // December (0-indexed)

const monthNames: string[] = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

const getLastDay = (year: number, month: number): number =>
  new Date(year, month, 0).getDate();

for (let year = startYear; year <= currentYear; year++) {
  // Use correct month range (0-11)
  const maxMonth = year === currentYear ? currentMonth : 11;

  for (let month = 0; month <= maxMonth; month++) {
    const monthNum = String(month + 1).padStart(2, "0");
    const lastDay = getLastDay(year, month + 1);
    const value = `${year}-${monthNum}-01,${year}-${monthNum}-${lastDay}`;
    const label = `${monthNames[month]}-${String(year).slice(2)}`;

    // Check with uppercase labels to match your defined exclusions

    if(year == 2025 && monthNames.indexOf(label.split("-")[0])>= 3){} else{
    DEFAULT_DATES.push({ value, label });}
    if (
      label === "JAN-19" ||
      label === "FEB-19" ||
      label === "MAR-19" ||
      label === "DEC-24"  // Fixed capitalization
      // label === "JAN-25" // Fixed capitalization
    ) {
      continue;
    }
    if (year >= 2025) {
      DEFAULT_DATES.push({
        value: `${value},Model 1`,
        label: `${label} Forecast`,
        forecast: true,
        model: "Model 1",
      });
    }
  }
}

// Reverse the array to maintain the descending order
DEFAULT_DATES.reverse();

interface MonthOption {
  value: string;
  label: string;
}

const getMonths = (): MonthOption[] => {
  const startYear = 2019;
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth(); // 0-indexed
  const endYear = 2025;
  const monthNames: string[] = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  const months: MonthOption[] = [];

  for (let year = startYear; year <= endYear; year++) {
    const maxMonth = year === currentYear ? currentMonth : 11; // Stop at current month if in 2025

    for (let month = 0; month <= maxMonth; month++) {
      const value = `${monthNames[month]} ${String(year).slice(2)}`;

      const label = `${monthNames[month]}-${String(year).slice(2)}`;

      months.push({ value, label });
    }
  }

  console.log(months);

  return months.reverse();
};

export default getMonths;

export const GROUP_BY = ["Total", "Discom"];

export const DataTabs = [
  { label: "Chart", value: "chart" },
  { label: "Summary", value: "summary" },
  { label: "Table", value: "table" },
];
